"use client";

import { useLayoutEffect, useState } from "react";

type ResponsiveState = {
	isMobile: boolean;
	isTablet: boolean;
	isDesktop: boolean;
	matchesCustom: boolean;
};

export function useResponsive(customQuery?: string): ResponsiveState {
	const [state, setState] = useState<ResponsiveState>({
		isMobile: false,
		isTablet: false,
		isDesktop: false,
		matchesCustom: false,
	});

	useLayoutEffect(() => {
		const mobileQuery = "(max-width: 767px)";
		const tabletQuery = "(min-width: 768px) and (max-width: 1024px)";
		const desktopQuery = "(min-width: 1025px)";
		const customMediaQuery = customQuery ? window.matchMedia(customQuery) : null;

		const updateState = () => {
			setState({
				isMobile: window.matchMedia(mobileQuery).matches,
				isTablet: window.matchMedia(tabletQuery).matches,
				isDesktop: window.matchMedia(desktopQuery).matches,
				matchesCustom: customMediaQuery ? customMediaQuery.matches : false,
			});
		};

		updateState(); // Set initial state

		// Add listeners for each media query
		const mobileMedia = window.matchMedia(mobileQuery);
		const tabletMedia = window.matchMedia(tabletQuery);
		const desktopMedia = window.matchMedia(desktopQuery);

		mobileMedia.addEventListener("change", updateState);
		tabletMedia.addEventListener("change", updateState);
		desktopMedia.addEventListener("change", updateState);
		customMediaQuery?.addEventListener("change", updateState);

		// Cleanup listeners on unmount
		return () => {
			mobileMedia.removeEventListener("change", updateState);
			tabletMedia.removeEventListener("change", updateState);
			desktopMedia.removeEventListener("change", updateState);
			customMediaQuery?.removeEventListener("change", updateState);
		};
	}, [customQuery]);

	return state;
}
